<template>
          <div class="container login-box-pos p-l-r-0" >
            <div class="login-box">
              <form>
                <div class="col-xs-12 col-sm-12 col-md-12 p-l-r-0">
                  <div class="form-group">
                      <input type="text" name="Username" v-model="UserId" id="Username" class="form-control input-sm" placeholder="Username">
                      
                      <span class="text-danger error">{{LoginError.email}}</span>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 p-l-r-0">
                  <div class="form-group">
                      <div class="password_field">
                        <input :type="passwordFieldType" name="Password" v-model="Password" id="Password" class="form-control input-sm" placeholder="Password">
                        <span class="show_password"  @click="switchVisibility" v-bind:class="{hide_pass: passwordFieldType == 'text'}"></span>
                      </div>
                      
                    
                      <span class="text-danger error">{{LoginError.password}}</span>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 p-l-r-0">
                  <div class="checkbox">
                      <label style="line-height: 1.42857143 !important;text-align:justify;" class="checkbox-container">
                          Remember me
                      
                     
                      <input type="checkbox" style="position: absolute;top: 0px;left: 0px;" id="remember-me"  name="remember-me">
                      <span class="checkmark"></span>
                      </label>
                  </div>
                  <div class="forgot-psw" style="text-align: right;">
                    <a href="#" class="forgot-password">Forgot password?</a>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 p-l-r-0 login-btn f-left">
                  <a href="javascript://" @click="SubmitLogin" class="btn">SUBMIT</a>
                </div>
                <div class="new-registration">
                  <span>Not Registered Yet?</span><a class="btn btn-white" href="#!" disabled type="submit">Sign Up</a>
                </div>
              </form>
            </div>
          </div>
      
</template>

<script>
// import authService from '../../services/auth'
// import Ls from '../../services/ls'
export default {
    name: 'Login',
    data() {
        return {
            UserId: '',
            Password: '',
            LoginError:{
                email:'',
                password:''
            },
            passwordFieldType: "password",
        }
    },
    methods: {
        SubmitLogin() {
            this.LoginError.email='';
            this.LoginError.password='';
             this.$store.dispatch('auth/login', {email:this.UserId,password:this.Password})
                .then(() => window.location.href="/login")
                .catch(error=>{
                    if(error.response.status==401){
                        this.$notify({ group: 'auth', text: error.response.data.error, type: 'warn' })
                    }
                    if(error.response.status==422){
                        var err= error.response.data.errors;
                        Object.keys(err).forEach((element) => {
                            this.LoginError[element]=err[element][0]
                        });
                        this.$notify({ group: 'auth', text: 'Please fill in information', type: 'warn' })
                    }
                })
        },
        switchVisibility(){
          this.passwordFieldType = this.passwordFieldType == 'password' ? 'text' : 'password'
        }
    },
    mounted(){
      var par= this.$route.query;
        if(Object.keys(par).length !== 0){
          console.log(par);
          this.$store.dispatch('auth/AutoLogin',{'session':par.session})
              .then(() =>{
                window.location.href="/"
                }
              );
        }
    }

};
</script>
<style  scoped>
  @import '../../assets/css/login.css';
</style>